import { FunctionComponent, memo } from "react";

import SentimentIcon from "../sentiment-icon";

import { IProps } from "./sentiment-icons.types";
import { getSentimentsFromProps } from "./sentiment-icons.utilities";
import "./sentiment-icons.scss";

/**
 * Icons indicating sentiment that is present.
 * @param props.hasFrustration Boolean indicating if frustration has been detected.
 * @param props.hasGratitude   Boolean indicating if gratitude has been detected.
 * @param props.hasPraise      Boolean indicating if praise has been detected.
 */
const SentimentIcons: FunctionComponent<IProps> = (props) => {
    // Filter out any sentiments that aren't present in the message.
    const sentiments = getSentimentsFromProps(props).filter((sentiment) => props[sentiment]);
    return (
        <div className="sentiment-icons">
            {sentiments.map((sentiment) => (
                <SentimentIcon key={sentiment} sentiment={sentiment} />
            ))}
        </div>
    );
};

export default memo(SentimentIcons);
